import { MonoBehavior } from 'game/core/monoBehavior';
import { Container, Graphics } from 'pixi.js';
import { getScreenSize } from 'game/core/screen';
import { Layout } from 'game/LayoutManager';
import gsap, { Power1 } from 'gsap';
import { theme } from 'game/theme';
import { MENU_TRANSITION_TIME } from 'constants/move';
import { Displays, DESKTOP_UI_WIDTH } from 'constants/layout';
import { EventName } from 'game/events/eventsName';
import { GameEvent } from 'game/events/gameEvent';

export class UIBackground extends MonoBehavior {
    container: Container;
    uiBg: Graphics;
    constructor(parentContainer: Container) {
        super();
        this.container = new Container();
        this.container.eventMode = 'static';

        this.uiBg = new Graphics();

        this.container.addChild(this.uiBg);

        parentContainer.addChild(this.container);
        GameEvent.add(EventName.START_TUTORIAL, this.onTutorialChange.bind(this, true));
        GameEvent.add(EventName.STOP_TUTORIAL, this.onTutorialChange.bind(this, false));
    }
    start(): void {
        this.handleOptions(false, true);
    }
    handleOptions(visible = false, onResize = false) {
        const { width, height } = getScreenSize();
        const easeTime = onResize ? 0 : MENU_TRANSITION_TIME;
        const device = Layout.getDisplay();
        this.container.zIndex = 1700;
        this.uiBg.clear();
        let backgroundAlpha = 0.82;
        switch (device) {
            case Displays.DESKTOP:
                this.uiBg.rect(0, 0, DESKTOP_UI_WIDTH, height);
                this.container.position.set(0, 0);
                this.container.zIndex = -1000;
                break;

            case Displays.TABLET:
                this.uiBg.rect(0, 0, DESKTOP_UI_WIDTH, height);

                gsap.to(this.container.position, {
                    x: visible ? width - DESKTOP_UI_WIDTH : width,
                    y: 0,
                    ease: Power1.easeInOut,
                    duration: easeTime,
                });

                break;
            case Displays.MOBILE:
                backgroundAlpha = 0.93;

                this.uiBg.rect(0, 0, width, height);

                gsap.to(this.container.position, {
                    x: visible ? 0 : width,
                    y: 0,
                    ease: Power1.easeInOut,
                    duration: easeTime,
                });

                break;
        }
        this.uiBg.fill(theme.uiBackground);
        gsap.to(this.uiBg, { alpha: visible ? backgroundAlpha : 0.3, ease: Power1.easeInOut, duration: easeTime });
    }

    onTutorialChange(isStarted: boolean) {
        if (isStarted) {
            gsap.to(this.container, { alpha: 0, duration: MENU_TRANSITION_TIME });
        } else {
            gsap.to(this.container, { alpha: 1, duration: MENU_TRANSITION_TIME });
        }
    }
}
